import React from 'react';

export default function PlayIcon() {
  return (
    <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1">
      <g id="play" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M18.0025665,1.48403494e-07 C10.7221429,-0.000931418486 4.15807862,4.38397295 1.37133551,11.1099399 C-1.4154076,17.8359069 0.124004857,25.5782925 5.27171236,30.7266588 C10.4194199,35.8750252 18.1616084,37.4154286 24.8879319,34.6295463 C31.6142555,31.843664 36,25.280161 36,17.9997374 C36,8.05965659 27.9426471,0.00127238295 18.0025665,1.48403494e-07 Z M13.7249223,26.0851068 L14.0128628,9.91436788 L25.9266893,18.2070545 L13.7249223,26.0851068 Z"
          id="Shape"
          fill="#0059B8"></path>
      </g>
    </svg>
  );
}
